import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-0"}],["path",{"d":"M10 16v-8m4 0v8","key":"svg-1"}],["path",{"d":"M10 12h4","key":"svg-2"}]]

const IconCircleLetterH = createReactComponent('outline', 'circle-letter-h', 'CircleLetterH', __iconNode);

export default IconCircleLetterH;